import { apiPost } from "./client";
import { ApiError } from "./client";
import { clearAllCookies } from "../../services/Cookies";
import { setAuthCookies } from "./refreshAuth";
import { useAppStore } from "../stores/useAppStore";

const BASE_URL = process.env.REACT_APP_API_URL ?? "";

export function createOrganization(data: {
  name: string;
  address: string;
  city: string;
  post_code: string;
  country: string;
  billing_address: string;
  billing_city: string;
  billing_post_code: string;
  billing_country: string;
}): Promise<void> {
  return apiPost<void>("/organization", data);
}

export async function checkValidInvitationOrganization(
  accessToken: string,
  tokenType: string,
): Promise<{ email: string }> {
  const response = await fetch(`${BASE_URL}/organization/user/check`, {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `${tokenType} ${accessToken}`,
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    throw new ApiError(response.status, response.statusText, null);
  }

  return response.json();
}

export async function registerFromInvitationOrganization(
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  accessToken: string,
  tokenType: string,
): Promise<any> {
  const response = await fetch(`${BASE_URL}/organization/user/register`, {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `${tokenType} ${accessToken}`,
    },
    body: JSON.stringify({
      first_name: firstName,
      last_name: lastName,
      email,
      password,
    }),
  });

  if (!response.ok) {
    throw new ApiError(response.status, response.statusText, null);
  }

  return response.json();
}

/** Apply auth cookies and trigger app init after a successful registration. */
export function applyAuthFromRegistration(data: {
  access_token: string;
  token_type: string;
  refresh_token?: string | null;
}): void {
  clearAllCookies();
  setAuthCookies({
    access_token: data.access_token,
    token_type: data.token_type,
    refresh_token: data.refresh_token ?? null,
  });
  useAppStore.getState().triggerInit();
}

export { ApiError };
